export default __webpack_public_path__ + "fonts/996cb4d61be3484e2d7ce8debfea1f7f.svg";